import { Calendar } from "../../components/Schedule"

const Schedule = () => {
    return (
        <>
            <div className="OrderInfo">
                <Calendar/>
            </div>
        </>
    )
}
export { Schedule }